import { useLocation } from 'react-router-dom'

export default function useBasePath() {
  const currentLocationParts = useLocation().pathname.split('/')
  if (currentLocationParts.length > 1) {
    return currentLocationParts[1]
  }
  return null
}
